import { render, staticRenderFns } from "./create_theme_copy.vue?vue&type=template&id=a6d4eb3a&scoped=true"
import script from "./create_theme_copy.vue?vue&type=script&lang=js"
export * from "./create_theme_copy.vue?vue&type=script&lang=js"
import style0 from "./create_theme_copy.vue?vue&type=style&index=0&id=a6d4eb3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d4eb3a",
  null
  
)

export default component.exports